import _ from 'lodash';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { AfterViewInit, Component, ElementRef, NgZone, ViewChild, Output, EventEmitter, Input} from '@angular/core';
import { CorpInfo, ForwarderService, License, License2, Office, Office2, Shipper, Shipper2, Contact, Contact2, Speciality, PagerService, CorpInfoTemp, GmapLogService } from '../../../services/index'
import { REST_API_REQUEST_CALL_URL, Util } from '../../../utils/index';
import { UserService, UserModel, LoadingService, Corporation, AlertService } from '../../../services/index'
import { MapsAPILoader } from '@agm/core';
import { FileUploader } from 'ng2-file-upload';
import { ActivatedRoute, ParamMap, Params } from '@angular/router';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { CKEditorComponent } from 'ng2-ckeditor';

declare var moment:any;

declare var $:any;
declare var google:any;

@Component({
  selector: 'corp-temp',
  templateUrl: 'corp-temp.html'
})
export class CorpTempComponenet implements AfterViewInit {

  _corpTempId:number;
  @Output() hideEe: EventEmitter<any> = new EventEmitter();
  @Output() saveComplete: EventEmitter<any> = new EventEmitter();
  @Input() set corpTempId(corpTempId:number){
    if(!corpTempId) return;
    this._corpTempId = corpTempId;
    this.getCorpInfoTemp(this._corpTempId);
  }

  @Input() licenseItemList;
  @Input() specialityItemList ;

  private corpInfo: CorpInfoTemp = new CorpInfoTemp();

  phoneFormatter: Function = Util.phoneFormatter;

  @ViewChild("corpAddress")
  corpAddressSearch: ElementRef;

  @ViewChild("fileInput")
  fileInput1: ElementRef;

  @ViewChild("fileInput2")
  fileInput2: ElementRef;
  
  autoComplete;

  uploader: FileUploader = new FileUploader({});
  uploader2: FileUploader = new FileUploader({});

  isSaving: boolean = false;

  apiUrl: string = '';

  showCompanyUsers: boolean = false;
  showCfs: boolean = false;

  officeList: Array<Office2> = [];
  licenseList: Array<License2> = [];
  shipperList: Array<Shipper2> = [];
  contactList: Array<Contact2> = [];

  filePreviewPath: SafeUrl;

  userInfo: UserModel = new UserModel();

  forwarderWarning: string = null;

  regNumberTemp: string = '';  
  regNumberCheck: boolean = true;
  corpId:number;

  updateCorpStatusSub:Subscription;

  startDt: string = moment(new Date()).format('YYYYMMDD');
  endDt: string = moment(new Date()).format('YYYYMMDD');

  ckEditorConfig = {
    extraPlugins: 'divarea,wordcount',
    "uiColor": "#ffffff",
    toolbarGroups:[
      { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
      { name: 'colors', groups: [ 'colors' ] },
      { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'paragraph' ] },
      { name: 'styles', groups: [ 'styles' ] }
    ],
    wordcount: {
      showParagraphs: true,
      showWordCount: true,
      showCharCount: false,
      countSpacesAsChars: false,
      countHTML: true,
      maxWordCount: 1000
    }
  };

  contactPager: any = {};
  contactPagedItems: any[];

  reqModifyTempList:Array<CorpInfoTemp> = new Array();

  @ViewChild("ckEditor") ckEditor: CKEditorComponent;

  constructor(
    private forwarderService: ForwarderService,
    private userService: UserService,
    private loadingService: LoadingService,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private alertService: AlertService,
    private router:Router,
    private pagerService: PagerService,
    private gmapLogService: GmapLogService
  ) {
    this.uploader2.onAfterAddingFile = (fileItem) => {
      this.filePreviewPath  = this.sanitizer.bypassSecurityTrustUrl((window.URL.createObjectURL(fileItem._file)));
    }
  }

  ngOnInit() {
    // this.forwarderService.getSpecialItemList().subscribe(
    //   resp=> {
    //     if(resp.result) {
    //       this.specialityItemList = resp.data;
    //     }
    //   } 
    // );

    // this.forwarderService.getLicenseItemList().subscribe(
    //   resp=> {
    //     if(resp.result) {
    //       console.log(resp.data);
    //       this.setLicenseItemList(resp.data);
    //     }
    //   }
    // );

    // this.userService.getUserInfoObs().subscribe(
    //   userInfo => {
    //     this.userInfo = userInfo;
    //     if(this.corpInfo.corpId == null || this.corpInfo.statusCd === 2) {
    //       if(userInfo.jobTp === '1') {
    //         this.corpInfo.typeCd = 1;
    //       } else if(userInfo.jobTp === '2') {
    //         this.corpInfo.typeCd = 3;
    //       }
    //     }
		// 	}
    // )

    this.apiUrl = REST_API_REQUEST_CALL_URL.BASE_URL;
  }

  getCorpInfoTemp(corpTempId){
    this.forwarderService.getCorpInfoTemp(corpTempId).subscribe(
      resp => {
        if(resp.result) {
          this.getForwarderInfo(resp.data);
          this.forwarderWarning = null;
        } else {
          this.forwarderWarning = resp.errorMsg;
        }
      }
    );
  }

  ngAfterViewInit(): void {
    this.loadingService.isClose = true;
    if(this.forwarderWarning == null) {
      const searchInput = this.corpAddressSearch.nativeElement;
      this.mapsAPILoader.load().then(() => {
        this.gmapLogService.log('corp-setting', 'PLACE');

        this.autoComplete = new google.maps.places.Autocomplete(searchInput, {fields: ["name", "formatted_address"]});

        let hasDownBeenPressed = false;
        
        searchInput.addEventListener('keydown', (e) => {
          if (e.keyCode === 40) {
            hasDownBeenPressed = true;
          }
        });
  
        google.maps.event.addDomListener(searchInput, 'keydown', (e) => {
          
          e.cancelBubble = true;
        
          if (e.keyCode === 13 || e.keyCode === 9) {
            if (!hasDownBeenPressed && !e.hasRanOnce) {
              google.maps.event.trigger(e.target, 'keydown', {
                  keyCode: 40,
                  hasRanOnce: true,
              });
            }
          }
        });
  
        searchInput.addEventListener('focus', () => {
          hasDownBeenPressed = false;
          searchInput.value = '';
        });
        
  
        this.autoComplete.addListener("place_changed", () => {
          this.ngZone.run(() => {
            let place = this.autoComplete.getPlace();
    
            if (place.geometry === undefined || place.geometry === null) {
              return;
            }
            searchInput.value = place.formatted_address;
            this.corpInfo.address = place.formatted_address;
          });
        });
      });   
    }
  }

  setPage(page: number) {
    if(this.corpInfo.contactList == null) return;
    this.contactPager = this.pagerService.getPager(this.contactList.length, page, 10);

    // if (page < 1) {
    //   return;
    // } 

    this.contactPagedItems =this.contactList.slice(this.contactPager.startIndex, this.contactPager.endIndex + 1);
  }

  
  getForwarderInfo(info) {
    this.corpInfo = info;
    if(info.officeList.length > 0) {
      this.officeList = info.officeList;
    } else {
      this.officeList.push(new Office2());

    }
    this.licenseList = info.licenseList;
    this.shipperList = info.shipperList;
    this.regNumberTemp = info.corpRegNo;
    this.corpId = this.corpInfo.corpId;
    this.contactList = info.contactList;
    this.setPage(1);
  }
  // setLicenseItemList(data) {
  //   this.licenseItemList = _.map(data, (license, index) => {
  //     license.value = license.itemId;
  //     license.label = license.itemNm + (license.remark ? ' (' + license.remark + ')' : '');
  //     return license;
  //   });
  // }

  setLicenseItem(event, index) {
    this.licenseList[index] = {
      isChecked: false,
      licenseId: event.licenseId,
      itemId: event.itemId,
      itemNm: event.itemNm,
      licenseRemark: event.remark,
      remark: null
    }
  }

  regNumSearch() {
    if(_.isEmpty(this.regNumberTemp)) {      
      $.sweetModal({
        content: '사업자등록번호를 입력해 주십시오.',        
        icon: $.sweetModal.ICON_WARNING
      });
      return;
    }

    this.forwarderService.findRegNo(this.regNumberTemp).subscribe(      
      resp => {
        this.regNumberCheck = resp.data;
        if(resp.data) {
          $.sweetModal({
            content: '사업자등록번호가 중복되었습니다. 다른 번호로 변경해 주십시오.',            
            icon: $.sweetModal.ICON_WARNING
          });
          this.regNumberCheck = resp.data;
        } else {
          $.sweetModal({
            content: '사업자등록번호가 중복되지 않았습니다. 계속 진행해 주십시오.',
            icon: $.sweetModal.ICON_WARNING
          });

          this.corpInfo.corpRegNo = this.regNumberTemp;          
        }
      }
    )
  }

  checkTableAll(table, checked) {
    if (!this.corpInfo) return;
    let list = this.getTableDataList(table);
    if (_.isEmpty(list)) return;

    for (let i = 0 ; i < list.length ; i++) {
      list[i].isChecked = checked;
    }
  }

  getTableDataList(table) {
    let list = null;

    if (table == 'office') {
      list = this.officeList;
    } else if (table == 'license') {
      list = this.licenseList;
    } else if (table == 'shipper') {
      list = this.shipperList;
    } else if (table == 'contact') {
      list = this.contactList;
    }
    return list;
  }

  setTableData(table, index, value) {
    if (!this.corpInfo) return;
    let list = this.getTableDataList(table);

    if (list && list[index]) {
      list[index].isChecked = value;
    }
  }

  addOffice() {
    this.officeList.push(new Office2());
  }

  addLicense() {
    this.licenseList.push(new License2());
  }  

  addShipper() {
    this.shipperList.push(new Shipper2());
  }

  addContact(){
    if(this.corpInfo.liner == null || this.corpInfo.liner.lineCd == null) return;

    let idx:number = 0;
    if(this.contactList.length > 0) {
      let temp = this.contactList[this.contactList.length-1];
      idx = temp.seq + 1;
    }
    this.contactList.push(new Contact2(this.corpInfo.liner.lineCd, this.corpInfo.liner.lineNm, idx));
    this.setPage(this.contactPager.endPage);
  }

  delRow(table) {
    if (!this.corpInfo) return;
    let list = this.getTableDataList(table);
    if (_.isEmpty(list)) return;
    for (let i = 0 ; i < list.length ; i++) {
      if (list[i].isChecked) {
        list.splice(i, 1);
        i--;
      }
    }
    if(table == 'contact'){
      this.setPage(1);
    }
  }
  
  getThisItemIsCheckd(itemId) {
    if(_.findIndex(this.corpInfo.specialityList, {itemId: itemId}) >= 0) {
      return 'checked';
    } else {
      return null;
    }
  }

  onChangeSpc(specialityItem, checked) {
    if (checked) {
      this.corpInfo.specialityList.push(specialityItem);
    } else {
      let index = _.findIndex(this.corpInfo.specialityList, {itemId: specialityItem.itemId});
      if (specialityItem.itemId == 23) this.corpInfo.specialityList[index].remark = null;
      this.corpInfo.specialityList.splice(index, 1);
    }

  }

  onChangeInputContact(index, fieldNm, value) {
    this.contactPagedItems[index][fieldNm] = value;
  }

  isDisabled(spcItemId) {
    const specialityList = this.corpInfo.specialityList;

    if (spcItemId === 1) {
      let find = _.find(specialityList, (spc) => {
        return (spc.itemId == 4)
      });

      if (find) return true;
      else return false;
    } else if (spcItemId === 2) {
      let find = _.find(specialityList, (spc) => {
        return (spc.itemId == 4 || spc.itemId == 5)
      });

      if (find) return true;
      else return false;
    } else if (spcItemId === 3) {
      let find = _.find(specialityList, (spc) => {
        return (spc.itemId == 5)
      });

      if (find) return true;
      else return false;
    } else if (spcItemId === 4) {
      let find = _.find(specialityList, (spc) => {
        return (spc.itemId == 1 || spc.itemId == 2 || spc.itemId == 5 || spc.itemId == 6)
      });

      if (find) return true;
      else return false;
    } else if (spcItemId === 5) {
      let find = _.find(specialityList, (spc) => {
        return (spc.itemId == 2 || spc.itemId == 3 || spc.itemId == 4 || spc.itemId == 6)
      });

      if (find) return true;
      else return false;
    } else if (spcItemId === 6) {
      let find = _.find(specialityList, (spc) => {
        return (spc.itemId == 4 || spc.itemId == 5 || spc.itemId == 7)
      });

      if (find) return true;
      else return false;
    } else if (spcItemId === 7) {
      let find = _.find(specialityList, (spc) => {
        return (spc.itemId == 6)
      });

      if (find) return true;
      else return false;
    }
    return false;
  }

  isEtcDisabled() {
    if (_.findIndex(this.corpInfo.specialityList, {itemId: 23}) >= 0 ) {
      return false;
    } else {
      return true;
    }
  }

  setEtcText(event) {
    let spcEtc = _.find(this.corpInfo.specialityList, {itemId: 23});
    if (!spcEtc) return;
    spcEtc.remark = event.target.value;
  }

  getEtcText() {
    let spcEtc = _.find(this.corpInfo.specialityList, {itemId: 23});
    if (!spcEtc) return null;
    else return spcEtc.remark;
  }

  addNewAutocomplete(index) {
    var input = document.getElementById('office' + index); 
    var autocomplete = new google.maps.places.Autocomplete(input, {fields: ["name", "formatted_address"]});

    let hasDownBeenPressed = false;
    
    input.addEventListener('keydown', (e) => {
      if (e.keyCode === 40) {
        hasDownBeenPressed = true;
      }
    });

    google.maps.event.addDomListener(input, 'keydown', (e) => {
      
      e.cancelBubble = true;
    
      if (e.keyCode === 13 || e.keyCode === 9) {
        if (!hasDownBeenPressed && !e.hasRanOnce) {
          google.maps.event.trigger(e.target, 'keydown', {
              keyCode: 40,
              hasRanOnce: true,
          });
        }
      }
    });

    input.addEventListener('focus', () => {
      hasDownBeenPressed = false;
      $(input).value = '';
    });
    

    autocomplete.addListener("place_changed", () => {
      this.ngZone.run(() => {
        let place = autocomplete.getPlace();

        if (place.geometry === undefined || place.geometry === null) {
          return;
        }
        $(input).value = place.formatted_address;
        this.officeList[index].address = place.formatted_address;
      });
    });
  }

  parseToDate(dateStr:string) {
    return moment(dateStr, 'YYYYMMDD').toDate();
  }

  close(){
    this.hideEe.emit();
  }

  approvalCorpTemp(){

    this.isSaving = true;
    
    if(this.corpInfo.typeCd == 2){
      //선사인 경우
      this.licenseList = null;
      this.shipperList = null;
      this.specialityItemList = _.filter(this.specialityItemList, (speciality:Speciality)=>{
        if(speciality.itemTpCd == 2) return true;
      });
    }else{
      //선사가 아닌 경우
      this.contactList = null;
      this.specialityItemList = _.filter(this.specialityItemList, (speciality:Speciality)=>{
        if(speciality.itemTpCd != 2) return true;
      });
    }

    if(this.corpInfo.statusCd === 0 || this.corpInfo.statusCd === 1) {
      this.regNumberCheck = false;
    }
    
    if(this.corpInfo.corpRegNo != this.regNumberTemp) {
      this.regNumberCheck = true;
    }

    this.corpInfo.officeList = new Array();
    this.corpInfo.licenseList = new Array();
    this.corpInfo.shipperList = new Array();
    this.corpInfo.contactList = new Array();

    if(this.officeList) {
      for(let i = 0; i<this.officeList.length; i++) {
        var office: Office = new Office();
        office = _.omit(this.officeList[i], 'isChecked');
        this.corpInfo.officeList.push(office);
      }
    }

    if(this.licenseList) {
      for(let i = 0; i<this.licenseList.length; i++) {
        var license: License = new License();
        license = _.omit(this.licenseList[i], 'isChecked');
        this.corpInfo.licenseList.push(license);
      }
    }

    if(this.shipperList) {
      for(let i = 0; i<this.shipperList.length; i++) {
        var shipper: Shipper = new Shipper();
        shipper = _.omit(this.shipperList[i], 'isChecked');
        this.corpInfo.shipperList.push(shipper);
      }
    }

    if(this.contactList) {
      for(let i = 0; i<this.contactList.length; i++) {
        var contact: Contact = new Contact();
        contact = _.omit(this.contactList[i], 'isChecked');
        this.corpInfo.contactList.push(contact);
      }
    }

    if(this.corpInfo.regUser != null && !this.corpInfo.regUser.userId) this.corpInfo.regUser = null;

    this.forwarderService.postApprovalCorpTemp(this._corpTempId, this.corpInfo).subscribe(
      resp => {
        if(resp.result){
          this.isSaving = false;
          this.saveComplete.emit();
        }
      }
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/containers/fwdr/detail/corp-temp.ts